import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * CONFIGURAÇÃO DE ENVIOS — e-mail, SMS e WhatsApp, por REDE e por ESCOLA.
 *
 * É daqui que sai tudo o que o sistema manda para fora (a tela de Enviar Mensagens e as
 * funcionalidades novas de responsabilidade da escola). A regra de escolha é UMA, no servidor: a
 * configuração da escola vale quando existe e está ativa; senão vale a da rede. Não tem
 * equivalente no legado — a permissão (2200100850) fica ao lado de Configurações (2200100800).
 */
export default [
  {
    description: 'Configuração de Envios',
    path: '/administracao/configuracaoenvios',
    name: 'configuracao_envios',
    component: () => import('@/views/administracao/configuracaoenvios/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CONFIGURACAODEENVIOSNOVO_MENU_2200100850],
    },
    goesToMenu: true,
  },
];
